import { useLocation } from "react-router-dom";
import { Lock } from "lucide-react";
import { API } from "@/lib/api";

export default function Login() {
  const location = useLocation();
  const error = location.state?.error;

  const signIn = () => {
    const frontendRedirect = window.location.origin + "/auth/callback";
    window.location.href = `${API}/auth/google/login?frontend_redirect=${encodeURIComponent(frontendRedirect)}`;
  };

  return (
    <div className="min-h-screen bg-zinc-900 flex flex-col items-center justify-center px-6 nrt-fade">
      <div className="w-full max-w-sm text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#365458] flex items-center justify-center mx-auto mb-6">
          <Lock className="w-7 h-7 text-white" />
        </div>
        <h1 className="font-heading text-4xl font-extrabold tracking-tight text-zinc-50">
          Next Right Thing
        </h1>
        <p className="text-zinc-400 mt-2 mb-10">A private space to capture, sort, and do.</p>

        {error && (
          <div data-testid="login-error" className="mb-6 rounded-xl bg-[#991B1B]/15 border border-[#991B1B]/40 px-4 py-3">
            <p className="text-[#FCA5A5] text-sm font-medium">{error}</p>
          </div>
        )}

        <button
          data-testid="google-signin-button"
          onClick={signIn}
          className="w-full h-16 rounded-2xl bg-zinc-100 hover:bg-white text-zinc-900 text-base font-bold flex items-center justify-center gap-3 transition-colors active:scale-[0.98]"
        >
          <svg className="w-5 h-5" viewBox="0 0 48 48">
            <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
            <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
            <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
            <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
          </svg>
          Sign in with Google
        </button>
        <p className="text-zinc-600 text-xs mt-6">Access is limited to one approved account.</p>
      </div>
    </div>
  );
}
